/*
|--------------------------------------------------------------------------
| Authentication Utility Functions
|--------------------------------------------------------------------------
*/

/**
 * Set authentication token
 * @param {string} token - Bearer token
 */
export const setAuthToken = (token) => {
    if (token) {
        // Remove 'Bearer ' prefix if it exists
        const cleanToken = token.replace(/^Bearer\s+/i, '');
        localStorage.setItem('token', cleanToken);
        console.log('Token set successfully');
    }
};

/**
 * Get authentication token
 * @returns {string|null} - Token or null if not found
 */
export const getAuthToken = () => {
    return localStorage.getItem('token');
};

/**
 * Remove authentication token
 */
export const removeAuthToken = () => {
    localStorage.removeItem('token');
    console.log('Token removed');
};

/**
 * Check if user is authenticated
 * @returns {boolean} - True if token exists
 */
export const isAuthenticated = () => {
    const token = getAuthToken();
    return !!token;
};

/**
 * Set the token from the example (for testing)
 * This is the token from your curl example
 */
export const setExampleToken = () => {
    const exampleToken = '67298|MokqstmfnBQOD2Z55esNrPu2Jik1qViiPnaFW5KS';
    setAuthToken(exampleToken);
    console.log('Example token set:', exampleToken);
};

/**
 * Initialize authentication
 * Call this when your app starts to check/set token
 */
export const initAuth = () => {
    // Check if token exists
    const token = getAuthToken();

    if (!token) {
        console.log('No token found. Setting example token for testing...');
        // For development/testing, set the example token
        setExampleToken();
    } else {
        console.log('Token found:', token);
    }

    return isAuthenticated();
};